import { DataGrid, DropDownBox } from "devextreme-react";
import {
  Column,
  ColumnFixing,
  FilterRow,
  Paging,
  Selection,
} from "devextreme-react/data-grid";
import React from "react";
import EsaedroLookupItem from "../../../Models/EsaedroLookupItem";
import { CustomColumn } from "../../../Models/Project/CustomColumn";
import ResourcesLookupsDisplayFields from "../../../Models/ResourcesLookupsDisplayFields";
import { NativeEventInfo } from "devextreme/events";
import dxDropDownBox from "devextreme/ui/drop_down_box";
import { ValueChangedInfo } from "devextreme/ui/editor/editor";
import { SelectBoxInstance } from "devextreme/ui/select_box";

type Props = {
  gridColumns: ResourcesLookupsDisplayFields[] | CustomColumn[];

  gridValue: any;

  itemsToDisplay: EsaedroLookupItem[];
  dataGridObjects: any[];

  fieldName: string; // Sarà il nome del campo che verrà passato al handleChange e che verrà cambiato
  valueColumnName: string; // Sarà il valore del KeyExpr e nella dataGrid il valueColumnName che servirà per recuperare il value nell'handlechange

  handleChange: (event: any) => void;

  gridDisabled?: boolean;
  isValid?: boolean;
  showClearButton?: boolean;
  onKeyDown?: (e: NativeEventInfo<SelectBoxInstance, KeyboardEvent>) => void;
};

const DelayedDataGrid2 = (props: Props) => {
  const {
    gridColumns,
    gridValue,
    itemsToDisplay,
    dataGridObjects,
    fieldName,
    valueColumnName,
    handleChange,
    gridDisabled,
    isValid = true,
    showClearButton = true,
    onKeyDown,
  } = props;

  const [isGridBoxOpened, setIsGridBoxOpened] = React.useState(false);

  const dataGridRender = () => {
    return (
      <DataGrid
        showBorders={true}
        showRowLines={true}
        showColumnLines={true}
        dataSource={dataGridObjects}
        hoverStateEnabled={false}
        selectedRowKeys={[gridValue]}
        onSelectionChanged={dataGridOnSelectionChanged}
        height="100%"
        disabled={gridDisabled !== undefined && gridDisabled}
        id={fieldName}
        elementAttr={{
          columnName: valueColumnName,
          field: fieldName,
        }}
      >
        <Selection mode={"single"} />
        <Paging enabled={true} pageSize={5} />
        <FilterRow visible={true} />
        <ColumnFixing enabled={true} />
        {gridColumns.map((c: any, i: number) => {
          return (
            <Column
              dataField={c.dataField ? c.dataField : c.DisplayField_Name}
              caption={c.caption ? c.caption : c.DisplayField_Description}
              fixed={c.FlagFixedColumn ? c.FlagFixedColumn : false}
              key={i}
            />
          );
        })}
      </DataGrid>
    );
  };

  const dataGridOnSelectionChanged = (e: any) => {
    //Proviene dal selectionChange delle DelayedDataGrid
    if (
      (e.selectedRowsData && e.selectedRowsData.length > 0) ||
      (e.event && e.event.type == "dxclick")
    )
      handleChange(e);
  };

  const syncDataGridSelection = (
    e: NativeEventInfo<dxDropDownBox, Event> & ValueChangedInfo
  ) => {
    setIsGridBoxOpened(false);

    if (e.event && e.event.type == "dxclick") dataGridOnSelectionChanged(e);
  };

  const onGridBoxOpened = (e: any) => {
    if (e.name === "opened") setIsGridBoxOpened(e.value);
  };

  const generateDisplayExpr = () => {
    let stringToRet: any = itemsToDisplay.find((item: EsaedroLookupItem) => {
      return item.value == gridValue;
    });

    if (stringToRet) return stringToRet.description;

    return "";
  };

  return (
    <DropDownBox
      dataSource={dataGridObjects}
      opened={isGridBoxOpened}
      displayExpr={generateDisplayExpr}
      value={gridValue}
      contentRender={dataGridRender}
      placeholder="Select a value..."
      showClearButton={showClearButton}
      valueExpr={valueColumnName}
      deferRendering={false}
      onValueChanged={syncDataGridSelection}
      onOptionChanged={onGridBoxOpened}
      disabled={gridDisabled}
      id={fieldName}
      elementAttr={{ field: fieldName }}
      isValid={isValid}
      onKeyDown={(e) => {
        if (onKeyDown) onKeyDown(e);
      }}
    />
  );
};

export default DelayedDataGrid2;
